export class ApiError {
    public readonly status: number;

    constructor(status: number) {
        this.status = status;
    }
}